<template>
  <div id="app">
   </div>
</template>

<script>
 import axios from 'axios';

export default {
  name: 'App',
  components: {
    
  },
  created(){
  
  },
  mounted(){
    console.log(this.$route);
    var shortCode = window.location.pathname.replace('/','')
    console.log(shortCode);
    this.getShortLinUrl(shortCode)
  },
  methods: {
    getShortLinUrl(code) {
      axios.post('https://callapi.ll-dr.cn/api/SMSMarketing/GetShortLinkByCode?code='+code)
        .then(response => {
          console.log(response.data.data.url)
          window.location.href = response.data.data.url
        })
        .catch(error => {
          console.error('There was an error!', error);
        });
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
